import React from 'react';
import clsx from 'clsx';
import styles from './filter-skeleton.module.scss';

const FilterSkeleton: React.FC<{ index?: number }> = ({ index = 0 }) => {
  return (
    <div
      role="presentation"
      className={styles.filterSkeleton}
    >
      <div className={clsx(styles.skeletonTitle, styles.gradient, index !== 0 && 'vc-d-none', 'vc-d-md-block')} />
      <div className={clsx(styles.skeletonText, styles.gradient, index !== 0 && 'vc-d-none', 'vc-d-md-block')} />
      <div className={clsx(styles.skeletonText, styles.gradient, 'vc-d-none', 'vc-d-md-block')} />
      <div className={clsx(styles.skeletonText, styles.gradient, index !== 0 && styles.skeletonText__collapsed)} />
    </div>
  );
};

export default FilterSkeleton;
